import { render, staticRenderFns } from "./ProductSupplySection.vue?vue&type=template&id=667feab0&"
import script from "./ProductSupplySection.vue?vue&type=script&lang=js&"
export * from "./ProductSupplySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports